interface ITcProductComponentStandardInformation {
    tcComponentStandardLabelOrder: string;
    tcComponentStandardLabelGrade: string;
    tcComponentCertifiedWeight: number;
  }
  
  interface ITcComponentRawMaterialInformation {
    tcComponentRawMaterialOrder: string;
    tcComponentRawMaterialPercentage: number;
    tcComponentRawMaterialCode: string;
  }
  
  interface ITcComponentInformation {
    tcProductComponentOrder: string;
    tcAssociatedProductNo: string;
    tcProductComponentNo: string;
    tcComponentDetail: string;
    tcComponentInfoTrimsExcluded: string;
    tcComponentInfoAssociatedTc: string;
    tcComponentInfoFiberLength: string;
    tcComponentInfoYarnCount: string;
    tcComponentInfoFabricWeightAndConstruct: string;
    tcComponentInfoFabricWeightOfFinishedProduct: string;
    tcComponentNetShippingWeight: number;
    tcComponentSupplementaryWeight: number;
    tcComponentInfoAdditional: string;
    tcProductComponentStandardInformation: ITcProductComponentStandardInformation[];
    tcComponentRawMaterialInformation: ITcComponentRawMaterialInformation[];
  }
  
  interface ITcPayload {
    etcId: string;
    tcComponentInformation: ITcComponentInformation[];
  }

export const mapJsonToPayload = (jsonData: any[], etcid: any) => {
    return {
        etcId: etcid, // Retaining the tcId
        tcComponentInformation: jsonData.map((item: any, index: any) => ({
            tcProductComponentOrder: (index + 1).toString() || "",
            tcAssociatedProductNo: item.tcAssociatedProductNo || "", // Default to empty string if not present
            tcProductComponentNo: item.tcProductComponentNo || "",
            tcComponentDetail: item.tcComponentDetail || "",
            tcComponentInfoTrimsExcluded: item.tcComponentInfoTrimsExcluded || "",
            tcComponentInfoAssociatedTc: item.tcComponentInfoAssociatedTc || "",
            tcComponentInfoFiberLength: (item.tcComponentInfoFiberLength).toString() || "", // Ensure it's a string
            tcComponentInfoYarnCount: item.tcComponentInfoYarnCount || "",
            tcComponentInfoFabricWeightAndConstruct: item.tcComponentInfoFabricWeightAndConstruct || "",
            tcComponentInfoFabricWeightOfFinishedProduct: item.tcComponentInfoFabricWeightOfFinishedProduct || "",
            tcComponentNetShippingWeight: parseInt(item.tcComponentNetShippingWeight, 10) || 0,
            tcComponentSupplementaryWeight: parseInt(item.tcComponentSupplementaryWeight, 10) || 0,
            tcComponentInfoAdditional: item.tcComponentInfoAdditional || "",
            tcProductComponentStandardInformation: (item["standard-info"] || []).map((standard: any) => ({
                tcComponentStandardLabelOrder: standard.tcComponentStandardLabelOrder.toString() || "",
                tcComponentStandardLabelGrade: standard.tcComponentStandardLabelGrade || "",
                tcComponentCertifiedWeight: parseInt(standard.tcComponentCertifiedWeight, 10) || 0
            })),
            tcComponentRawMaterialInformation: (item["raw-materials-info"] || []).map((rawMaterial: any) => ({
                tcComponentRawMaterialOrder: rawMaterial.tcComponentRawMaterialOrder.toString() || "",
                tcComponentRawMaterialPercentage: rawMaterial.tcComponentRawMaterialPercentage || "",
                tcComponentRawMaterialCode: rawMaterial.tcComponentRawMaterialCode || ""
            }))
        })),
        additionalProp1: {}
    };
};


export const payloadToJsonMap = (payload: any) => {
    return {
        etcId: payload.etcId,
        data: payload.tcComponentInformation.map((componentInfo: any, index: number) => ({
            tcAssociatedProductNo: componentInfo.tcAssociatedProductNo,
            tcProductComponentOrder: componentInfo.tcProductComponentOrder,
            tcProductComponentNo: componentInfo.tcProductComponentNo,
            tcComponentDetail: componentInfo.tcComponentDetail,
            tcComponentInfoTrimsExcluded: componentInfo.tcComponentInfoTrimsExcluded,
            tcComponentInfoAssociatedTc: componentInfo.tcComponentInfoAssociatedTc,
            tcComponentInfoFiberLength: componentInfo.tcComponentInfoFiberLength,
            tcComponentInfoYarnCount: componentInfo.tcComponentInfoYarnCount,
            tcComponentInfoFabricWeightAndConstruct: componentInfo.tcComponentInfoFabricWeightAndConstruct,
            tcComponentInfoFabricWeightOfFinishedProduct: componentInfo.tcComponentInfoFabricWeightOfFinishedProduct,
            tcComponentNetShippingWeight: componentInfo.tcComponentNetShippingWeight,
            tcComponentSupplementaryWeight: componentInfo.tcComponentSupplementaryWeight,
            tcComponentInfoAdditional: componentInfo.tcComponentInfoAdditional,

            // Map "standard-info" array
            "standard-info": componentInfo.tcProductComponentStandardInformation.map((standardInfo: any) => ({
                tcComponentStandardLabelOrder: standardInfo.tcComponentStandardLabelOrder.toString(),
                tcComponentStandardLabelGrade: standardInfo.tcComponentStandardLabelGrade,
                tcComponentCertifiedWeight: standardInfo.tcComponentCertifiedWeight
            })),

            // Map "raw-materials-info" array
            "raw-materials-info": componentInfo.tcComponentRawMaterialInformation.map((rawMaterialInfo: any) => ({
                tcComponentRawMaterialOrder: rawMaterialInfo.tcComponentRawMaterialOrder,
                tcComponentRawMaterialPercentage: rawMaterialInfo.tcComponentRawMaterialPercentage,
                tcComponentRawMaterialCode: rawMaterialInfo.tcComponentRawMaterialCode
            }))
        }))
    };
};
